/**
 * IMPORTS
 */
import graphis from 'src/services/graphis';
import {CREATE_TAG} from 'src/aggregates/tags/mutations';
import {UPDATE_TAG} from 'src/aggregates/tags/mutations';
import {FETCH_TAGS} from 'src/aggregates/tags/queries';


/**
 * TYPES
 */
import {ITag} from 'src/aggregates/tags/graphis.d';
import {ICreateTagResponse} from 'src/aggregates/tags/mutations.d';
import {IUpdateTagResponse} from 'src/aggregates/tags/mutations.d';
import {IUpdateTagPatch} from 'src/aggregates/tags/mutations.d';
import {IUpdateTagVariables} from 'src/aggregates/tags/mutations.d';
import {IFetchCustomersByCompanyResponse} from 'src/aggregates/tags/queries.d';


/**
 * CODE
 */

/**
 * I create a tag.
 *
 * :param name: tag name
 * :param company: company id
 *
 * :returns: created tag
 */
async function createTag(name: string, company: number): Promise<ITag | null>
{
    // initialize response
    let response: ICreateTagResponse;

    // create tag
    try
    {
        response = await graphis.mutate(CREATE_TAG, {company, name});
    }

    // create tag failed: log and return null
    catch (e)
    {
        console.error(e);
        return null;
    }

    // return customers
    return response.data.createTag;
}


/**
 * I get tags of a given company.
 *
 * :param company: company id
 *
 * :returns: company tags
 */
async function loadTags(company: number): Promise<ITag[] | null>
{
    // initialize response
    let response: IFetchCustomersByCompanyResponse;

    // fetch tags
    try
    {
        response = await graphis.query(FETCH_TAGS, {company});
    }

    // load tags failed: log and return null
    catch (e)
    {
        console.error(e);
        return null;
    }

    // return customers
    return response.data.tags;
}


/**
 * I update a given tag.
 *
 * :param id: tag id
 * :param name: tag name to be updated for
 * :param company: tag company to be updated for
 *
 * :returns: updated tag or null
 */
async function updateTag(
    id: number,
    patch: IUpdateTagPatch,
): Promise<ITag | null>
{
    // set response
    let response: IUpdateTagResponse;

    // set variables
    const variables: IUpdateTagVariables = {id, patch};

    // update tag
    try
    {
        response = await graphis.mutate(UPDATE_TAG, variables);
    }

    // update tag failed: log and return null
    catch (e)
    {
        console.error(e);
        return null;
    }

    // update tag successfully: return updated tag
    return response.data.updateTag;
}


/**
 * EXPORTS
 */
export {
    createTag,
    loadTags,
    updateTag,
};
